import React from 'react';
import './MyApps.css';
import { FaWordpress } from 'react-icons/fa';
import { memo } from 'react';
//using memo to make sure component does not re-render after navbar prop changes.

const MyApps = () => {
  return (
    <div>
      <h2>Apps</h2>
      <div className='app_container'>
        <div className='app_container_1'>
          <a
            href='https://firebrandbbq.com.au/wp-admin'
            target='_blank'
            rel='noreferrer'
            className='app_anchor'
          >
            <FaWordpress />
            <span>Woocommerce</span>
          </a>
          <a
            href='https://my.hikeup.com/'
            target='_blank'
            rel='noreferrer'
            className='app_anchor'
          >
            <FaWordpress />
            <span>HikePos</span>
          </a>
          <a
            href='https://login.xero.com/identity/user/login'
            target='_blank'
            rel='noreferrer'
            className='app_anchor'
          >
            <FaWordpress />
            <span>Xero</span>
          </a>
        </div>
        <div className='app_container_1'>
          <a
            href='https://app.starshipit.com/Account/MemberLogin.aspx'
            target='_blank'
            rel='noreferrer'
            className='app_anchor'
          >
            <FaWordpress />
            <span>Starshipit</span>
          </a>
          <a
            href='https://fireterminal.netlify.app'
            target='_blank'
            rel='noreferrer'
            className='app_anchor'
          >
            <FaWordpress />
            <span>Fireterminal</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default memo(MyApps);
